import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as EventTicketPackageProfileActivitiesActions from './event-ticket-package-profile-activities.actions'
import { EventTicketPackageProfileActivitiesEntity } from './event-ticket-package-profile-activities.models'

export const EVENT_TICKET_PACKAGE_PROFILE_ACTIVITIES_FEATURE_KEY = 'eventTicketPackageProfileActivities'

export interface EventTicketPackageProfileActivitiesState
  extends EntityState<EventTicketPackageProfileActivitiesEntity> {
  selectedId?: string | number // which EventTicketPackageProfileActivities record has been selected
  error?: string | null // last known error (if any)
}

export interface EventTicketPackageProfileActivitiesPartialState {
  readonly [EVENT_TICKET_PACKAGE_PROFILE_ACTIVITIES_FEATURE_KEY]: EventTicketPackageProfileActivitiesState
}

export const eventTicketPackageProfileActivitiesAdapter: EntityAdapter<EventTicketPackageProfileActivitiesEntity> =
  createEntityAdapter<EventTicketPackageProfileActivitiesEntity>({
    selectId: (activity: EventTicketPackageProfileActivitiesEntity) => activity.ticket_package.uuid,
  })

export const initialEventTicketPackageProfileActivitiesState: EventTicketPackageProfileActivitiesState =
  eventTicketPackageProfileActivitiesAdapter.getInitialState()

const eventTicketPackageProfileActivitiesReducer = createReducer(
  initialEventTicketPackageProfileActivitiesState,
  on(EventTicketPackageProfileActivitiesActions.syncEventTicketPackageProfileActivitySuccess, (state, action) =>
    eventTicketPackageProfileActivitiesAdapter.upsertOne(action.activity, state),
  ),
  on(EventTicketPackageProfileActivitiesActions.deleteEventTicketPackageProfileActivity, (state, action) =>
    eventTicketPackageProfileActivitiesAdapter.removeOne(action.uuid, state),
  ),
  on(
    EventTicketPackageProfileActivitiesActions.updateSelectedEventTicketPackageProfileActivityId,
    (state, { uuid }) => ({
      ...state,
      selectedId: uuid,
    }),
  ),
  on(EventTicketPackageProfileActivitiesActions.clearSelectedEventTicketPackageProfileActivityId, (state) => ({
    ...state,
    selectedId: '',
  })),
  on(EventTicketPackageProfileActivitiesActions.clearEventTicketPackageProfileActivities, (state) => ({
    ...initialEventTicketPackageProfileActivitiesState,
  })),
)

export function reducer(state: EventTicketPackageProfileActivitiesState | undefined, action: Action) {
  return eventTicketPackageProfileActivitiesReducer(state, action)
}
